module.exports = __webpack_public_path__ + "img/company47.d90a9a21.png";